import styled from 'styled-components';
import { ExpertiseListType } from './types';

export const PovsExpertiseRightSideContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  gap: 10px;
`;

export const ExpertiseListsContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

export const ExpertiseListFeedbacks = styled.div<ExpertiseListType>`
  .text {
    font-size: 16px;
    line-height: 19px;
    font-weight: 400;
    color: #606d7c;
  }

  .link {
    color: #1272ba;
    font-size: 16px;
    text-decoration: underline;
    cursor: pointer;
    border: 0;
    background: none;
    text-align: start;
  }

  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px 0;

  border-bottom: 1.4px #d6dde6 ${(props) => (props.border ? 'solid' : 'none')};
`;

export const ExpertiseListFeedback = styled.div`
  width: 100%;
  padding: 10px 0 0 0;

  display: flex;
  flex-direction: column;

  gap: 10px;

  .grade {
    color: #7594b9;
    font-size: 15px;
  }
`;
